import styled from "styled-components";

export const Card = styled.div`
  width: 17rem;
  height: 10rem;
  background: #141E30;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #243B55, #141E30);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #243B55, #141E30); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  color: #f3f3f3;
  border-radius: 0.6rem;
  background-size: contain;
  background-repeat: no-repeat;
  filter: drop-shadow(3px 5px 10px #000);
  padding: 1rem;
  box-sizing: content-box;
  cursor: pointer;
`;
export const ContainerImg = styled.div`
  height: 10rem;
  display: flex;
  justify-content: center;
  & img {
    object-fit: cover;
  }
`;
export const Cardetails = styled.div`
  overflow: scroll;

  & h1 {
    font-size: 0.9rem;
    font-weight: bolder;
    text-align: center;
  }
  & p {
    font-size: 0.7rem;
    text-align: justify;
  }
`;

export const Year = styled.small`
  font-weight: bolder;
`;
